import * as React from "react";
import { OneKeyOnboardingWrapper as SharedUIOneKeyOnboarding } from "@shared-ui/retail-loyalty-one-key-onboarding";

export const OneKeyOnboarding = () => <SharedUIOneKeyOnboarding additionalContext={{}} />;

export default OneKeyOnboarding;
